import { useNavigate } from "react-router-dom";
import { CheckCircle, ArrowRight } from "lucide-react";
import { tailwind } from "@/utilities/tailwind-utils";
import { Button } from "@/components/ui/button";

// Logout Page
export default function LogoutPage() {
  const navigate = useNavigate();

  const handleRedirectToLogin = () => {
    navigate("/login", { replace: true });
  };

  return (
    <div
      className={
        tailwind.layout.wrapperCenter +
        " " +
        tailwind.backgrounds.bgBackground +
        " " +
        tailwind.spacing.p4
      }
    >
      <div className={tailwind.layout.flexColGap6}>
        <div
          className={
            tailwind.layout.flexCenter +
            " " +
            tailwind.sizes.size8 +
            " " +
            tailwind.borders.roundedFull +
            " " +
            tailwind.backgrounds.bgPrimary +
            "/10 mx-auto mb-4"
          }
        >
          <CheckCircle className={tailwind.sizes.size5} />
        </div>
        <div className={tailwind.typography.textCenter}>
          <h1
            className={
              tailwind.typography.text2xl +
              " " +
              tailwind.typography.fontBold +
              " " +
              tailwind.spacing.mb2
            }
          >
            Successfully logged out
          </h1>
          <p className={tailwind.typography.textMuted}>
            You have been logged out of your account.
          </p>
        </div>
        <div className={tailwind.layout.flexColGap4}>
          <div
            className={
              tailwind.typography.textSmMuted +
              " " +
              tailwind.backgrounds.bgMuted +
              "/50 " +
              tailwind.spacing.p4 +
              " " +
              tailwind.borders.roundedMd
            }
          >
            <p>
              Your session has been terminated and all authentication tokens
              have been cleared.
            </p>
          </div>
          <div
            className={
              tailwind.typography.textSm +
              " text-destructive " +
              tailwind.backgrounds.bgDestructive +
              "/10 " +
              tailwind.spacing.p4 +
              " " +
              tailwind.borders.roundedMd
            }
          >
            <p>
              For security reasons, you will need to log in again to access
              protected resources.
            </p>
          </div>
        </div>

        {/* Redirect Button */}
        <div className={tailwind.layout.flexCenter + " mt-6"}>
          <Button
            onClick={handleRedirectToLogin}
            className={tailwind.layout.flexCenterGap2}
            size="lg"
          >
            <ArrowRight className={tailwind.sizes.size4} />
            Return to Login
          </Button>
        </div>
      </div>
    </div>
  );
}
